import React from 'react';
import classnames from 'classnames';

import Label from '../Label/Label';

import styles from './Rating.module.scss';

const RatingLabel = (props) => {
  const {
    label, name, labelClassName, hasError
  } = props;

  if (!label) return null;

  return (
    <Label
      htmlFor={name}
      hasError={hasError}
      label={label}
      className={classnames(styles.labelClassName, labelClassName)}
    />
  );
};

export default RatingLabel;
